import { render, staticRenderFns } from "./TituloDepositos.vue?vue&type=template&id=4fbf64c0&"
import script from "./TituloDepositos.vue?vue&type=script&lang=js&"
export * from "./TituloDepositos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports